import type { Modifier } from '@dnd-kit/core';
import { getEventCoordinates } from '@dnd-kit/utilities';
import { domElIdCreators } from 'src/helpers';

export const anchorPaddingPx = 4;

export const snapCursorToPoint: Modifier = ({ activatorEvent, draggingNodeRect, transform }) => {
  const dragOverlayEl = document.getElementById(domElIdCreators.fieldOverlayEl());
  if (!dragOverlayEl || !draggingNodeRect || !activatorEvent) return transform;

  const { width } = dragOverlayEl.getBoundingClientRect();
  const activatorCoordinates = getEventCoordinates(activatorEvent);
  if (!activatorCoordinates) return transform;

  const offsetY = activatorCoordinates.y - draggingNodeRect.top;
  const offsetX = activatorCoordinates.x - draggingNodeRect.left - width;

  return {
    ...transform,
    x: transform.x + offsetX + anchorPaddingPx,
    y: transform.y + offsetY - anchorPaddingPx,
  };
};
